/**
 * Admin-API: SSO-Token-Exchange Admin -> App (telephonio.com).
 *
 * Aus admin.aimafia.de heraus tauscht ein eingeloggter Member seinen
 * Member-JWT gegen einen User-JWT, mit dem er ohne erneuten SMS-Login
 * im Kunden-Frontend landet. Backend legt bei Bedarf einen User on-the-fly
 * an (`loginOrRegisterUserByPhone` mit Auto-AI + Pool-Number).
 *
 * Antwort: `{ token, userId, phone, created, onboarding_* }`.
 */

function authHeaders(token) {
  return { Authorization: "Bearer " + (token || "") };
}

export async function exchangeToUser({ apiBase, token }) {
  const r = await fetch(`${apiBase}/api/admin/exchange-to-user`, {
    method: "POST",
    headers: authHeaders(token),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {
    const e = new Error(j.error || "Wechsel in die App fehlgeschlagen");
    e.status = r.status;
    e.code = j.code || null;
    throw e;
  }
  return j;
}
